import * as React from "react";
import Loader from 'react-loader';
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import { toast, ToastContainer} from 'react-toastify';
import {Button,Col, Input, Row} from 'reactstrap';

import SortableTable from "../../../../components/Admin/PaginationTable/PaginationTable.Component";
import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';
import { Wrapper, Content , ContentRow} from './SubscriptionsList.styles'

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class ListSubscriptions extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        // this.goToProfileEdit = this.goToProfileEdit.bind(this);
        this.fetchsubscriptions = this.fetchsubscriptions.bind(this);
        this.viewMoreData = this.viewMoreData.bind(this);
    }

    public customTD = (props) => {
        return (
          <td>
            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button
              className="blue-button"
              style={{ margin: "0 .75em .5em 0", padding: ".375em", fontSize: "16px" }}
              onClick={this.viewMoreData.bind(this, props)}
            >
               Edit Subscription 
            </button>
          </td>
        );
      };

      public viewMoreData(props) {
        const history: any = this.props.history;
        history.push(`/admins/subscriptions/${props.rowData.id}`);
      }

    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'home/';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    
    public onLogout() {
        this.setState({ toLogin: true });
    }

   

    public async fetchsubscriptions(page, size, searchString) {
        const {
          services: { adminAPI },
        } = this.props;

       const membersRes = await adminAPI.getAllSubscriptions(page, size, searchString);
   
       if (membersRes.ok) {
         const subscriptions = membersRes.data.subscriptions;
   
         this.setState({
           ...this.state,
           data: {
             ...this.state.data,
             subscriptions,
             pageCount: membersRes.data.page_count,
           },
         });
       } else {
         toast.error("Error fetching interaction details!");
       }
     }

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

 
        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const subscriptionsDataKey = ["id", "UserName", "PackageName", "Email", "Type"];
        
        const subscriptionsThead = ["ID", "Name", "Package", "Email", "Action"];

        const subscriptionsRes = await adminAPI.getAllSubscriptions(1, 10);

        if (subscriptionsRes.ok) {
            
            const subscriptions = subscriptionsRes.data.subscriptions;

            this.setState(
                {
                     data: {
                        subscriptions,
                        loaded: true,
                        subscriptionsDataKey,
                        subscriptionsThead,
                        pageCount: subscriptionsRes.data.page_count
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>

              <Content>
              <SortableTable
            {...this.props}
            tableData={data.subscriptions}
            tableHead={data.subscriptionsThead}
            dataKeys={data.subscriptionsDataKey}
            apiCall={this.fetchsubscriptions}
            pageCount={data.pageCount}
            customTd={[
              {
                custd: this.customTD,
                keyItem: "Type",
                sortable: false,
              }
            ]}
            searchKey="subscriptions"
          />

              </Content>
              </Wrapper>
        );

    }

}

export default withServices(ListSubscriptions);


// WEBPACK FOOTER //
// ./src/pages/Admin/Subscriptions/ListSubscriptions/SubscriptionsList.tsx